// extracted by mini-css-extract-plugin
export default {"translateBtn":"TranslateButton_translateBtn__qXLzf","loading":"TranslateButton_loading__WxJ-2","error":"TranslateButton_error__catKx"};